import React, { useContext } from "react";
import "./Portfolio.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar } from "swiper";
import { motion } from "framer-motion";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import estateHomePage from "../../img/screenshot1.png";
import estateDashboard from "../../img/screenshot2.png";
import estateProperty from "../../img/screenshot3.png";
import healthDashboard from "../../img/dash.JPG";
import lama from "../../img/lama.jpeg";

import { themeContext } from "../../Context";

const Portfolio = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  const slides = [
    {
      title: "Dwellmate Real Estate Project",
      link: "https://makao-648bd.firebaseapp.com",
      image: estateHomePage,
    },
    {
      title: "Coalition network California Health Dashboard",
      link: "https://healthdashboard12.web.app/",
      image: healthDashboard,
    },
    {
      title: "Dwellmate real estate project dashboard",
      link: "https://makao-648bd.firebaseapp.com/dashboard",
      image: estateDashboard,
    },
    {
      title: "Bumihouse Real Estate Project",
      link: "http://185.47.174.186/",
      image: lama,
    },
    
  ];

  return (
    <div className="portfolio" id="portfolio">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      > <div className="heading">
        <span style={{ color: darkMode ? "white" : "" }}>Recent Projects</span>
        <span>Portfolio</span>
        </div>
        <Swiper
          spaceBetween={20}
          grabCursor={true}
          navigation={true}
          modules={[Navigation, Pagination, Scrollbar]}
          scrollbar={{ draggable: true }}
          className="portfolio-slider"          
            breakpoints={{
  0: { slidesPerView: 1, spaceBetween: 0 },   // mobile
  600: { slidesPerView: 2, spaceBetween: 15 }, // tablets
  1024: { slidesPerView: 2.7, spaceBetween: 15 } // large screens (only 2 slides)
}}>
          {slides.map((slide, index) => (
            <SwiperSlide key={index}>
              <motion.a
                href={slide.link}
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 200 }}
                className="portfolio-slide-link"
              >
                <img src={slide.image} alt={slide.title} loading="lazy" />
                <p  style={{ color: darkMode ? "white" : "" }} className="portfolio-title">{slide.title}</p>
                <button className="portfolio-button">View live</button>
              </motion.a>
            </SwiperSlide>
          ))}
        </Swiper>
      </motion.div>
    </div>
  );
};

export default Portfolio;
